import { DataGrid, formatDate } from '@ijoin/components';
import { useGetAdminAnnuityAccountCreationErrors } from '@ijoin/hooks';
import { Stack, Typography } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';

const AnnuityAccountErrorsScreen = () => {
  const errors = useGetAdminAnnuityAccountCreationErrors();

  return (
    <Stack spacing={2} sx={{ height: '100%', p: 2 }}>
      <Typography variant='h5'>Annuity Account Errors</Typography>

      {errors.data?.createdAt && (
        <Typography data-testid='reportCreatedAt' variant='body2'>
          Errors from the run at{' '}
          {formatDate(errors.data.createdAt, {
            format: 'MM/DD/YYYY h:mm:ss A'
          })}
        </Typography>
      )}

      <DataGrid
        autoHeight={false}
        columns={[
          {
            field: 'participantId',
            flex: 1,
            headerName: 'Participant ID',
            minWidth: 300
          },
          {
            field: 'firstName',
            flex: 1,
            headerName: 'First Name',
            minWidth: 120
          },
          {
            field: 'lastName',
            flex: 1,
            headerName: 'Last Name',
            minWidth: 120
          },
          {
            field: 'planCorrelationId',
            flex: 1,
            headerName: 'Plan Correlation ID',
            minWidth: 300
          },
          {
            field: 'description',
            flex: 1,
            headerName: 'Plan',
            minWidth: 200
          },
          {
            field: 'advisoryOrganizationName',
            flex: 1,
            headerName: 'Advisory Organization',
            minWidth: 200
          },
          {
            field: 'message',
            flex: 2,
            headerName: 'Error Message',
            minWidth: 400
          }
        ]}
        disableRowSelectionOnClick
        getRowId={row => row.annuityPolicyParticipantsId}
        initialState={{
          pagination: { paginationModel: { page: 0, pageSize: 25 } }
        }}
        loading={errors.isFetching}
        pageSizeOptions={[25, 50, 100]}
        rows={errors.data?.data ?? []}
        showColumnMenu
        slotProps={{
          noRowsOverlay: { message: 'No errors in the latest run' },
          root: {
            'data-component': 'dataGrid',
            'data-testid': 'annuityAccountCreationErrors'
          }
        }}
        sx={{ flex: 1, minHeight: 0 }}
      />
    </Stack>
  );
};

export const Route = createFileRoute('/annuity-account-errors')({
  component: AnnuityAccountErrorsScreen
});
